import { useTranslation } from "react-i18next";
import { useAreaCrumbs } from "@/components/areaCrumbs";
import { PageBreadcrumbs } from "@/components/PageBreadcrumbs";
import { SkillForm } from "./SkillForm";

/** /build/skills/new — the create page (no modal). */
export function NewSkillPage() {
  const { t } = useTranslation("skills");
  const areas = useAreaCrumbs();
  return (
    <div className="flex flex-col">
      <PageBreadcrumbs trail={[areas.build, { label: t("title"), to: "/build/skills" }]} current={t("form.create")} />
      <div className="mx-auto flex w-full max-w-3xl flex-col gap-6 px-4 py-6 md:px-8">
        <SkillForm />
      </div>
    </div>
  );
}
